module.exports = __webpack_public_path__ + "img/bac_06.6c0fce61.jpg";